"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LiveChat = void 0;
var _react = _interopRequireDefault(require("react"));
var _LiveChat = _interopRequireDefault(require("./LiveChat.render"));
var _LiveAgent = require("../../../../../../modules/LiveAgent");
var _getLiveAgentClient = _interopRequireDefault(require("../../../../../../utils/getLiveAgentClient"));
var _isAnalyticsChannel = _interopRequireDefault(require("../../../../../../utils/isAnalyticsChannel"));
var _withLocale = _interopRequireDefault(require("../../../../../HOCs/withLocale"));
let liveAgent;
class LiveChat extends _react.default.Component {
  constructor(props) {
    super(props);
    this.onChat = () => {
      if (this.state.isAvailable) {
        liveAgent.startChat();
      }
    };
    this.visibilityChange = isAvailable => {
      this.setState({
        isAvailable
      });
    };
    if (!liveAgent) liveAgent = (0, _getLiveAgentClient.default)({
      locale: this.props.locale
    });
    this.state = {
      isAvailable: liveAgent.isAvailable
    };
  }
  componentDidMount() {
    liveAgent.addListener(_LiveAgent.AVAILABILITY_CHANGE, this.visibilityChange);
  }
  componentWillUnmount() {
    liveAgent.removeListener(_LiveAgent.AVAILABILITY_CHANGE, this.visibilityChange);
  }
  render() {
    const isEnabled = !(0, _isAnalyticsChannel.default)();
    if (!isEnabled) return null;
    return (
      /*#__PURE__*/
      // @ts-ignore
      _react.default.createElement(_LiveChat.default, {
        isAvailable: this.state.isAvailable,
        children: this.props.children,
        onChat: this.onChat
      })
    );
  }
}

// @ts-ignore
exports.LiveChat = LiveChat;
var _default = exports.default = (0, _withLocale.default)(LiveChat);